import React from 'react';
import PropTypes from 'prop-types';
import {loginUiTexts} from 'data/ui-texts';
import Button from 'components/button/button';
import Tab from 'components/layout/tab';

const LoginTeacher = (props) => {
	let {
		handleInput,
		handleLogin,
		goToTeacherBox,
		email,
		password,
		feedback,
		isLoading,
		invalidInputEmail,
		invalidInputPassword
	} = props;

	return (
		<Tab title={<div className="Login-title">{loginUiTexts.teacher} <span>\\</span> {loginUiTexts.login}</div>} >
			<form className="Login-form" onSubmit={handleLogin}>
				<div className="frame"></div>
				<input
					className={invalidInputEmail ? ' invalid' : ''}
					name="email"
					type="text"
					placeholder={loginUiTexts.placeholderEmail} 
					autoComplete="section-teacherlogin email"
					value={email ? email : ''} 
					onChange={(event)=>{handleInput(event);}}
				/>
				<input
					className={invalidInputPassword ? ' invalid' : ''}
					name="password"
					type="password"
					placeholder={loginUiTexts.placeholderPassword}
					autoComplete="section-teacherlogin password"
					value={password ? password : ''} 
					onChange={(event)=>{handleInput(event);}}
				/>
				<Button
					isLoading={isLoading}
					text={loginUiTexts.loginBtn}
					onClick={(event)=>{handleLogin(event);}}
				/>
				<p className={'Login-errorMessage'}>{feedback}</p>
	
			</form>
			<Button 
				class="loginToggle"
				text={loginUiTexts.resetPassword}
				onClick={()=>{goToTeacherBox('resetPassword');}}
			/>
			<Button 
				class="loginToggle"
				text={loginUiTexts.createUserMessage}
				onClick={()=>{goToTeacherBox('createUser');}}
			/>
		</Tab>
	);
};

LoginTeacher.propTypes = {
	handleLogin: PropTypes.func.isRequired,
	goToTeacherBox: PropTypes.func.isRequired,
	handleInput: PropTypes.func.isRequired,
	email: PropTypes.string,
	password: PropTypes.string,
	feedback: PropTypes.string,
	isLoading: PropTypes.bool.isRequired,
	invalidInputEmail: PropTypes.bool.isRequired,
	invalidInputPassword: PropTypes.bool.isRequired
};

export default LoginTeacher;